import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router'
import { getAggreementFormReview } from '../../../../auth/services/apiCalling';
import { toast, ToastContainer } from 'react-toastify';
import html2pdf from 'html2pdf.js';


const CertificateMD = () => {
    const location = useLocation()
    const applicationId = location?.state?.Sponsor_Id;
    const [appData, setAppData] = useState(null)
    const token = useSelector((state: any) => state.auth.token);
    const userDetail = useSelector((state: any) => state.auth.userDetails);
    
    const certificateRef = useRef(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [validity, setValidity] = useState();

    const roleIdentifier = userDetail?.Role?.Role_Identifier;

    

    const formReviewDetails = async () => {
        const resp = await getAggreementFormReview(token, applicationId);
        if (resp?.success == true) {
            setAppData(resp?.data)
        } else {
            toast.error(resp?.message, { position: "top-right" });
        }
    }

    const getPeriodOfMonths = () => {
        if (appData) {
            const found = appData?.uploadedText?.Cultivation?.find((item: any) => item.periodOfMonths);
            return found ? found.periodOfMonths : null;
        }
    };

    useEffect(() => {
        const mm = getPeriodOfMonths();
        setValidity(mm)
    }, [appData])



    useEffect(() => {
        formReviewDetails();
    }, [applicationId])

    const handleDownloadPDF = () => {
        setIsDownloading(true);

        const element = certificateRef.current;
        const opt = {
            margin: 10,
            filename: `Certificate_${applicationId}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };

        html2pdf().set(opt).from(element).save().then(() => {
            setIsDownloading(false);
            toast.success('Certificate downloaded successfully!', { position: "top-right" });
        }).catch((error) => {
            setIsDownloading(false);
            toast.error('Failed to download certificate', { position: "top-right" });
          
        });
    };

    return (
        <div className={`${roleIdentifier == 'SPO' && 'page-wrapper'} `}>
            <div className='m-5 text-black' style={{ fontSize: "1rem" }}>
                <div className='d-flex pb-3 justify-content-between'>
                    <div>
                        <h3>Agreement Review - Form M</h3>
                        <p>Congratulations! Your stamped agreement has been approved and your final approval certificate is now available for download.</p>
                    </div>
                    <div>
                        <button
                            className='btn btn-primary'
                            onClick={handleDownloadPDF}
                            disabled={isDownloading || !appData}
                        >
                            {isDownloading ? 'Downloading...' : 'Download Certificate'}
                        </button>
                    </div>
                </div>
                <div className='w-100 px-5 py-4 bg-white'>
                    <div className='w-100 bg-white' ref={certificateRef}>

                        <h3>Certificate</h3>
                        <hr className='bg-dark' />

                        <div>
                            <p>ગુજરાત રાજ્ય કૃષિ ઉત્પાદન બજાર બોર્ડ <br /> (ગુજરાત કૃષિ ઉત્પાદન બજાર અધિનિયમ, 1963 હેઠળ સ્થાપિત)</p>
                            <p>કોન્ટ્રાક્ટ ફાર્મિંગ એગ્રીમેન્ટનું રજીસ્ટ્રેશન અને મંજૂરી પ્રમાણપત્ર</p>
                            <p>આથી પ્રમાણિત કરવામાં આવે છે કે <span className='fw-bold'>{userDetail?.Sponsor_Name}</span>, <br /> જેનું રજીસ્ટર્ડ ઓફિસ સરનામું <span className='fw-bold'>{userDetail?.Sponsor_Address}</span> છે <br /> તેને ગુજરાત કૃષિ ઉત્પાદન બજાર નિયમો, નિયમ 119 (ગુજરાત અધિનિયમ નં. 8, 2020 દ્વારા કરવામાં આવેલા સુધારા મુજબ) હેઠળ કોન્ટ્રાક્ટ ફાર્મિંગ સ્પોન્સર તરીકે યોગ્ય રીતે રજીસ્ટ્રેશન આપવામાં આવ્યું છે.</p>
                            <p>સ્પોન્સરે ખેડૂત(ઓ) સાથે કોન્ટ્રાક્ટ ફાર્મિંગ એગ્રીમેન્ટ કરેલ છે અને તે એગ્રીમેન્ટનું ગુજરાત રાજ્ય કૃષિ ઉત્પાદન બજાર બોર્ડ (GSAMB) દ્વારા ચકાસણી, સમીક્ષા અને રજીસ્ટ્રેશન કરવામાં આવ્યું છે</p>
                            <p>આ પ્રમાણપત્ર સ્પોન્સરને ગુજરાત રાજ્યમાં કોન્ટ્રાક્ટ ફાર્મિંગ પ્રવૃત્તિઓ હાથ ધરવા માટે અધિકૃત કરે છે, જે રજીસ્ટર્ડ એગ્રીમેન્ટની શરતો તથા ગુજરાત કૃષિ ઉત્પાદન બજાર અધિનિયમ, 1963 અને તેમાં થયેલા સુધારા મુજબ છે</p>
                            <p>પ્રમાણપત્ર નંબર: {applicationId}
                                <br />રજીસ્ટ્રેશન તારીખ: {appData?.agreement_day_of} 20{appData?.agreement_twozerozero}
                                <br />માન્યતા: {validity}
                            </p>
                            <p>આ પ્રમાણપત્ર ગુજરાત રાજ્ય કૃષિ ઉત્પાદન બજાર બોર્ડ ના અધિકાર હેઠળ આજના {appData?.forwardToMBMDAterApproval?.updatedAt.slice(0, 10)} ના રોજ ગાંધીનગર, ગુજરાત ખાતે આપવામાં આવે છે.</p>

                            <hr className='bg-black' />

                            <p>GUJARAT STATE AGRICULTURAL MARKETING BOARD <br /> (Established under the Gujarat Agricultural Produce Markets Act, 1963)</p>
                            <p>Certificate of Registration and Approval of Contract Farming Agreement</p>
                            <p>This is to certify that <span className='fw-bold'>{userDetail?.Sponsor_Name}</span>, <br /> having its registered office at <span className='fw-bold'>{userDetail?.Sponsor_Address}</span>, <br /> has been duly registered as a Contract Farming Sponsor under Rule 119 of the Gujarat Agricultural Produce Markets Rules, as amended by Gujarat Act No. 8 of 2020.</p>
                            <p>The sponsor has executed a Contract Farming Agreement with the farmer(s) as per the provisions of the Act and Rules, and the said agreement has been reviewed, verified, and registered with the Gujarat State Agricultural Marketing Board (GSAMB).</p>
                            <p>This certificate entitles the Sponsor to carry out contract farming activities in Gujarat as per the terms and conditions of the registered agreement and in compliance with the Gujarat Agricultural Produce Markets Act, 1963 and subsequent amendments.</p>
                            <p>Certificate Number: {applicationId}
                                <br />Registration Date: {appData?.agreement_day_of} 20{appData?.agreement_twozerozero}
                                <br />Validity: {validity}
                            </p>
                            <p>Issued under the authority of the Gujarat State Agricultural Marketing Board on this {appData?.forwardToMBMDAterApproval?.updatedAt.slice(0, 10)} at Gandhinagar, Gujarat.</p>

                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />

        </div>
    )
}

export default CertificateMD